import {useDispatch, useSelector} from "react-redux";
import moment from "moment";
import {setEditLoan} from "../../../../_reducers/DataPanel/Cash/cashSlice";
import {Accordion, Badge, Button, Col, Modal, Row} from "react-bootstrap";
import Input from "../../../common/Input";
import AccountingBox from "../../../primer/AccountingBox";
import DateBox from "../../../primer/DateBox";
import React, {useEffect, useState} from "react";
import LogTable from "../../../primer/LogTable";
import {
    checkPermissionStartingTree,
    getGreekCurrencyFormat,
    isEmpty,
    quickClone
} from "../../../../_helpers/commonFunctions";
import {toast} from "react-toastify";
import {FaRegTrashAlt} from "react-icons/fa";
import Dropdown from "../../../primer/Dropdown";
import axios from "axios";
import {constructInstitutesOptions} from "../Banking/constants";

const EditLoan = () => {
    const dispatch = useDispatch();
    const editLoan = useSelector((state) => state.CASH_DATA.editLoan);

    const [showAddPayment, setShowAddPayment] = useState(false);
    const defaultNewPayment = {
        date: moment().toDate(),
        principalAmount: 0,
        interestAmount: 0,
        totalAmount: 0,
    }
    const [addPayment, setAddPayment] = useState({...defaultNewPayment});

    const [showDelete, setShowDelete] = useState(false);
    const [toDeleteIdx, setToDeleteIdx] = useState(0);

    const [institutes, setInstitutes] = useState([]);
    const permissionsData = JSON.parse(localStorage.getItem("permissions"));
    const instituteOptions = constructInstitutesOptions(institutes, permissionsData);

    useEffect(() => {
        if (!showAddPayment) {
            const prepObj = {...defaultNewPayment};
            if (editLoan.payments.length >= 1) {
                const lastOne = editLoan.payments[editLoan.payments.length - 1];
                prepObj.principalAmount = lastOne.principalAmount;
                prepObj.interestAmount = lastOne.interestAmount;
                prepObj.totalAmount = lastOne.totalAmount;
            }
            setAddPayment({...prepObj});
        }
    }, []);

    useEffect(() => {
        fetchInstitutes();
    }, []);

    const formatEditLoan = (obj) => {
        obj.remainingPrincipal = +Number(obj.principal - obj.payments.reduce((sum, item) => sum + item.principalAmount, 0)).toFixed(2);
        return obj;
    }

    const handleOnChange = (e, type, name) => {
        const prepChange = {};
        if (type === "dd") {
            prepChange[name] = e.value;
        } else if (type === "db") {
            if (moment(e).isValid()) prepChange[name] = moment(e).toDate();
            else prepChange[name] = "";
        } else if (type === "ab") {
            let val = e.target.value;
            if (isNaN(+val) || +val <= 0) val = 0;
            else val = +Number(val).toFixed(2);
            prepChange[name] = val;
        } else if (type === "input") {
            prepChange[name] = e.target.value;
        }
        dispatch(setEditLoan(formatEditLoan({...editLoan, ...prepChange})));
    }

    const handleAddPayment = () => {
        if (isEmpty(addPayment.date) || isEmpty(addPayment.interestAmount) || isEmpty(addPayment.principalAmount) || isEmpty(addPayment.totalAmount)) {
            return toast.error("Παρακαλώ συμπληρώστε όλα τα πεδία.");
        } else if (+addPayment.interestAmount === 0 && addPayment.principalAmount.principalAmount === 0) {
            return toast.error("Παρακαλώ συμπληρώστε θετικά ποσά.");
        }
        setShowAddPayment(false);
        toast.success("Επιτυχής καταχώρηση, μην ξεχάσετε να αποθηκεύσετε.");
        dispatch(setEditLoan(formatEditLoan({...editLoan, payments: [...editLoan.payments, addPayment]})));
    }

    const onDelete = () => {
        const cloneIt = quickClone(editLoan.payments);
        cloneIt.splice(toDeleteIdx, 1);
        dispatch(setEditLoan(formatEditLoan({...editLoan, payments: cloneIt})));
        toast.success("Επιτυχής διαγραφή, μην ξεχάσετε να αποθηκεύσετε.");
        setShowDelete(false);
    }

    const handleDelete = (idx) => {
        setToDeleteIdx(idx);
        setShowDelete(true);
    }

    const fetchInstitutes = () => {
        axios.get(`${process.env.REACT_APP_API_URL2}/accounting/banking-institutes`, {
            headers: { 'Content-Type': 'application/json' },
        }).then((res) => {
            if (res.data.status === "200") {
                setInstitutes([
                    {id: "PRXBGRAA", name: "Viva Bank"},
                    ...res.data.data,
                ]);
            }
        }).catch((err) => {
            console.log(err);
        })
    }

    return (
        <div className={"mb-3"}>
            <Row className={"mb-3"}>
                <Col md={3}>
                    <Dropdown
                        className={"mb-2"}
                        name={"bank_institute"}
                        label={"Τραπεζικό Ίδρυμα"}
                        options={instituteOptions}
                        required={true}
                        defaultValue={instituteOptions.find((el) => el.value === editLoan.bank_institute)}
                        onChange={(e) => handleOnChange(e, "dd", "bank_institute")}
                    />
                </Col>
                <Col md={3}>
                    <Input
                        name={"numbering"}
                        label={"Κωδικός Δανείου"}
                        required={true}
                        value={editLoan.numbering}
                        autoComplete={"off"}
                        onChange={(e) => handleOnChange(e, "input", "numbering")}
                    />
                </Col>
                <Col md={3}>
                    <label>Ποσό Κεφαλαίου (€)</label>
                    <AccountingBox
                        name={"amount"}
                        key={editLoan.principal}
                        defaultValue={editLoan.principal}
                        required={true}
                        onBlur={(e) => handleOnChange(e, "ab", "principal")}
                    />
                </Col>
                <Col md={3}>
                    <label>Επιτόκιο Δανεισμού (%)</label>
                    <AccountingBox
                        name={"interestRate"}
                        key={editLoan.interestRate}
                        defaultValue={editLoan.interestRate}
                        suffix={"%"}
                        required={true}
                        onBlur={(e) => handleOnChange(e, "ab", "interestRate")}
                    />
                </Col>
                <Col md={3}>
                    <DateBox
                        name={"startDate"}
                        label={"Ημερομηνία Έναρξης"}
                        selected={moment(editLoan.startDate).isValid() ? moment(editLoan.startDate).toDate() : null}
                        allowOtherYears={true}
                        required={true}
                        onChange={(e) => handleOnChange(e, "db", "startDate")}
                    />
                </Col>
                <Col md={3}>
                    <Input
                        name={"years"}
                        label={"Διάρκεια σε έτη"}
                        type={"number"}
                        required={true}
                        value={editLoan.years}
                        onChange={(e) => handleOnChange(e, "input", "years")}
                    />
                </Col>
                <Col md={3}>
                    <label>Υπόλοιπο Κεφαλαίου (€)</label>
                    <AccountingBox
                        name={"amount"}
                        key={editLoan.remainingPrincipal}
                        defaultValue={editLoan.remainingPrincipal}
                        disabled={true}
                    />
                </Col>
                {checkPermissionStartingTree("accounting", permissionsData) && (
                    <Col md={3}>
                        <Input
                            name={"accounting"}
                            label={"Λογιστικός Λογαριασμός"}
                            value={editLoan.accounting}
                            autoComplete={"off"}
                            onChange={(e) => handleOnChange(e, "input", "accounting")}
                        />
                    </Col>
                )}
            </Row>
            <Row>
                <Col md={12}>
                    <Accordion defaultActiveKey={editLoan.payments.length > 10 ? "" : "0"}>
                        <Accordion.Item eventKey="0">
                            <Accordion.Header>Ιστορικό Πληρωμών</Accordion.Header>
                            <Accordion.Body>
                                <Button size={"sm"} className={"mb-2"} onClick={() => setShowAddPayment(true)}>+ Προσθήκη πληρωμής</Button>
                                {editLoan.payments.length > 0 && (
                                    <table className={"transfers-table"}>
                                        <thead>
                                        <tr>
                                            <th>Αρ.</th>
                                            <th>Ημερομηνία Πληρωμής</th>
                                            <th>Ποσό κεφαλαίου</th>
                                            <th>Ποσό τόκου</th>
                                            <th>Συνολικό ποσό δόσης</th>
                                            <th>Ενέργειες</th>
                                        </tr>
                                        </thead>
                                        {editLoan.payments.map((p, idx) => (
                                            <tr key={`lp-${idx}`} style={{fontSize: "16px"}}>
                                                <td>{String(idx + 1)}</td>
                                                <td>{moment(p.date).format("DD/MM/YYYY")}</td>
                                                <td>{getGreekCurrencyFormat(p.principalAmount)}</td>
                                                <td>{getGreekCurrencyFormat(p.interestAmount)}</td>
                                                <td>{getGreekCurrencyFormat(p.totalAmount)}</td>
                                                <td>
                                                    <Badge bg={"danger"} style={{cursor: "pointer", padding: "4px", margin: "4px"}} title={"Διαγραφή"} onClick={() => handleDelete(p)}>
                                                        <FaRegTrashAlt size={17} />
                                                    </Badge>
                                                </td>
                                            </tr>
                                        ))}
                                    </table>
                                )}
                            </Accordion.Body>
                        </Accordion.Item>
                    </Accordion>
                </Col>
            </Row>

            <Modal show={showAddPayment} onHide={() => setShowAddPayment(false)} backdrop={"static"}>
                <Modal.Header closeButton>
                    <Modal.Title>Προσθήκη Πληρωμής</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <DateBox
                        name={"date"}
                        label={"Ημερομηνία"}
                        classes={"mb-1"}
                        selected={moment(addPayment.date).isValid() ? moment(addPayment.date).toDate() : null}
                        allowOtherYears={true}
                        required={true}
                        onChange={(e) => {
                            const prepChange = {};
                            if (moment(e).isValid()) prepChange["date"] = moment(e).toDate();
                            else prepChange["date"] = "";
                            setAddPayment({...addPayment, ...prepChange});
                        }}
                    />
                    <label>Ποσό Κεφαλαίου (€)</label>
                    <AccountingBox
                        name={"principalAmount"}
                        key={Math.random()}
                        className={"mb-2 form-control"}
                        fromAccountTable={true}
                        defaultValue={addPayment.principalAmount}
                        required={true}
                        onBlur={(e) => {
                            let val = e.target.value;
                            if (isNaN(+val) || +val <= 0) val = 0;
                            else val = +Number(val).toFixed(2);
                            setAddPayment({
                                ...addPayment,
                                principalAmount: val,
                                totalAmount: +Number(addPayment.interestAmount + val).toFixed(2),
                            });
                        }}
                    />
                    <label>Ποσό Τόκου (€)</label>
                    <AccountingBox
                        name={"interestAmount"}
                        fromAccountTable={true}
                        key={Math.random()}
                        className={"mb-2 form-control"}
                        defaultValue={addPayment.interestAmount}
                        required={true}
                        onBlur={(e) => {
                            let val = e.target.value;
                            if (isNaN(+val) || +val <= 0) val = 0;
                            else val = +Number(val).toFixed(2);
                            setAddPayment({
                                ...addPayment,
                                interestAmount: val,
                                totalAmount: +Number(addPayment.principalAmount + val).toFixed(2),
                            });
                        }}
                    />
                    <label>Συνολικό Ποσό Δόσης (€)</label>
                    <AccountingBox
                        name={"totalAmount"}
                        fromAccountTable={true}
                        className={"mb-2 form-control"}
                        key={Math.random()}
                        defaultValue={addPayment.totalAmount}
                        disabled={true}
                    />
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="outline-primary" onClick={() => setShowAddPayment(false)}>
                        Κλείσιμο
                    </Button>
                    <Button variant="primary" onClick={() => handleAddPayment()}>
                        Προσθήκη
                    </Button>
                </Modal.Footer>
            </Modal>

            <Modal show={showDelete} onHide={() => setShowDelete(false)} backdrop={"static"}>
                <Modal.Header closeButton>
                    <Modal.Title>Διαγραφή πληρωμής</Modal.Title>
                </Modal.Header>
                <Modal.Body>Είσαστε σίγουροι ότι θέλετε να διαγράψετε την πληρωμή αυτή;</Modal.Body>
                <Modal.Footer>
                    <Button variant="outline-primary" onClick={() => setShowDelete(false)}>
                        Όχι, άκυρο
                    </Button>
                    <Button variant="outline-danger" onClick={() => onDelete()}>
                        Ναι, διαγραφή
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    )
}

export const EditLoanLog = () => {
    const editLoan = useSelector((state) => state.CASH_DATA.editLoan);

    return (
        <React.Fragment>
            <div className="text-muted mb-2"><i>Ιστορικό Δανείου</i></div>
            <LogTable itemId={editLoan._id}/>
        </React.Fragment>
    )
}

export default EditLoan;
